// Browser support HTML Dialog element
export const supportsDialog = () => typeof HTMLDialogElement === "function";
